<template>
  <keep-alive>
    <component :is="layout"></component>
  </keep-alive>
</template>

<script>
import Desktop from "./desktop";
import Mobile from "./mobile";
export default {
  components: {
    Desktop,
    Mobile,
  },
  computed: {
    layout: (vm) => (vm.$root.isDesktop ? "Desktop" : "Mobile"),
  },
};
</script>
